import React from 'react';

interface SharedDownloadOverlayProps {
  isVisible: boolean;
  message?: string;
}

const SharedDownloadOverlay: React.FC<SharedDownloadOverlayProps> = ({ 
  isVisible, 
  message = "Generating Invoice..." 
}) => {
  if (!isVisible) return null;

  return (
    <div 
      className="shared-download-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        backdropFilter: 'blur(1px)',
        pointerEvents: 'auto',
        animation: 'fadeInScale 0.3s ease-out'
      }}
    >
      <div 
        className="overlay-content"
        style={{
          backgroundColor: '#ffffff',
          padding: '40px',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
          textAlign: 'center',
          maxWidth: '450px',
          width: '90%',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}
      >
        <div 
          className="shimmer-loader"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: 'linear-gradient(90deg, #0077F9 25%, #0056b3 50%, #0077F9 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.5s infinite',
            margin: '0 auto 25px auto'
          }}
        />
        <h4 style={{ 
          color: '#333', 
          marginBottom: '15px', 
          fontWeight: '600',
          fontSize: '18px'
        }}>
          {message}
        </h4>
        <p style={{ 
          color: '#666', 
          fontSize: '16px', 
          margin: 0, 
          lineHeight: '1.5' 
        }}>
          Please wait while we prepare your PDF. This may take a few moments.
        </p>
      </div>
    </div>
  );
};

export default SharedDownloadOverlay; 